import {Component, input} from "@angular/core";
import {NavbarComponent} from "../navbar/navbar.component";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrl: "./header.component.scss",
  imports: [
    NavbarComponent,
  ],
})
export class HeaderComponent {
  public readonly backgroundImage = input<string>();
  public readonly title = input.required<string>();
  public readonly description = input<string>();
}
